import getStore from '../store/store';
import { State } from '../store/schema/State';

export function getStoreIsSettled(): boolean {
    switch (getStore().state) {
        case State.Initialized:
        case State.Error:
            return true;
        case State.Uninitialized:
        default:
            return false;
    }
}
